function init() {   
	jQuery("img.svg").each(function(t) {
		var i = jQuery(this),
			a = i.attr("id"),
			n = i.attr("class"),
			e = i.attr("src");
		jQuery.get(e, function(t) {
			var e = jQuery(t).find("svg");
			void 0 !== a && (e = e.attr("id", a)), void 0 !== n && (e = e.attr("class", n + " replaced-svg")), e = e.removeAttr("xmlns:a"), i.replaceWith(e)
		}, "xml")
	}), setTimeout(func, 500);

	$("body").addClass("load-page");
};

var ct = 0;
$(window).scroll(function() {

  $('header').each(function() {
    var hh = $('header').height();
    
    var top = $(window).scrollTop(),
        h = $(window).height(),
        header = $('header');
    if (!$('body').hasClass('menu-open')) {
      if (top > hh) {
        header.addClass('fixed');
        $('.cart').removeClass('in');
      } else {
        header.removeClass('fixed')
      }
      if (ct > top) {
        header.addClass('sticky');
      } else {
        header.removeClass('sticky');
      }
      ct = top;
    }

    
  });
});

$('.icon-menu').click(function(){
  $('body').toggleClass('menu-open');
});
$('.icon-burger').click(function(){
  $('body').toggleClass('menu-content-open');
});
$('.menu-open:after').click(function(){
  $('body').toggleClass('menu-open');
});

function stickyFooter() {
	var f = $('footer').outerHeight(),
		h = $('header').outerHeight(),
		m = $('main'),
		height = parseInt(f) + parseInt(h) + 2;
		// console.log(height);
		m.css('min-height','calc(100vh - '+height+'px');
};


//BACK TO TOP
$('.backtotop a').on('click', function() {
$("html, body").animate({
  scrollTop: 0
}, 1100);
});

$('.excerpt').each(function(){
	var t = $(this),
		btn = t.find('.more'),
		text = btn.text(),
		text2 = btn.data('less');

	// console.log(t.find('.text').outerHeight());

	if(t.find('.text').outerHeight() > 24) {
		t.addClass('less');
	} else {
		btn.hide();
	}

	btn.click(function(e){
		e.preventDefault();
		t.toggleClass('less');
		if(t.hasClass('less')){
			btn.text(text)
		}else{
			btn.text(text2);
		}
	})
})

function animation() {
	$(".animation-on-scroll").each(function() {
		var bottom_of_object = $(this).offset().top + 10;
		var bottom_of_window = $(window).scrollTop() + $(window).height();

		if( bottom_of_window > bottom_of_object ){
			$(this).addClass('animate-in');
		}
	})
}

// Select all links with hashes
function pScroll(){
	$('.subscribes a.btn-red[href*="#"]')
	  // Remove links that don't actually link to anything
	  .not('[href="#"]')
	  .not('[href="#0"]')
	  .click(function(event) {
	    // On-page links
	    if (
	      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
	      location.hostname == this.hostname
	    ) {
	      // Figure out element to scroll to
	      var target = $(this.hash);
	      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
	      // Does a scroll target exist?
	      if (target.length) {
	        // Only prevent default if animation is actually gonna happen
	        event.preventDefault();
	        $('html, body').animate({
	          scrollTop: target.offset().top
	        }, 2000, function() {
	          // Callback after animation
	          // Must change focus!
	          var $target = $(target);
	          $target.focus();
	          if ($target.is(":focus")) { // Checking if the target was focused
	            return false;
	          } else {
	            $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
	            $target.focus(); // Set focus again
	          };
	        });
	      }
	    }
	  });
	};

function AdScroll(){	
	$('a.arrow-down.scroll[href*="#"]')
	  // Remove links that don't actually link to anything
	  .not('[href="#"]')
	  .not('[href="#0"]')
	  .click(function(event) {
	    // On-page links
	    if (
	      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
	      location.hostname == this.hostname
	    ) {
	      // Figure out element to scroll to
	      var target = $(this.hash);
	      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
	      // Does a scroll target exist?
	      if (target.length) {
	        // Only prevent default if animation is actually gonna happen
	        event.preventDefault();
	        $('html, body').animate({
	          scrollTop: target.offset().top
	        }, 1000, function() {
	          // Callback after animation
	          // Must change focus!
	          var $target = $(target);
	          $target.focus();
	          if ($target.is(":focus")) { // Checking if the target was focused
	            return false;
	          } else {
	            $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
	            $target.focus(); // Set focus again
	          };
	        });
	      }
	    }
	  });
	};

function func() {

	setTimeout(function() {
		animation();
	}, 600);

	// $('a[target!="_blank"]' || 'a[href !="#"]').click(function(t) {
	// 	t.preventDefault();
	// 	href = this.href;
	// 	$("body").addClass("link-transition");
	// 	setTimeout(function() {
	// 		window.location = href
	// 	}, 500)
	// });
	$('.masthead').each(function(){
		var t = $(this);
		setTimeout(function() {
			t.addClass('appear');
		}, 600)
	});


	$('.modal').on('hidden.bs.modal', function (e) {
		$("body").removeClass("link-transition");
	})

	$('header .menu-icon').click(function(){
		$('body').toggleClass('menu-open');
	});

	$('header').each(function(){
		var s = $(this).find('.has-sub');

		if($(window).width() <= 900){
			s.each(function(){
				$(this).click(function(e){
					e.preventDefault();
					$(this).toggleClass('sub-open');
				})
				$(this).find('.sub-menu a').click(function(e){
					e.stopPropagation();
				})
			})          
		}
		
	});

	$('.select').each(function(){
		var select  = $(this),
			w  = select.data('width') == undefined ? '100%' : select.data('width');

		select.selectpicker({
			style: 'select-control',
			width: w,
			size: 4
		});
	});

	$('.gfield_select').each(function(){
		var select  = $(this),
			w  = select.data('width') == undefined ? '100%' : select.data('width');

		select.selectpicker({
			style: 'select-control',
			width: w,
			size: 4
		});
	});

	$(document).bind('gform_post_render', function() {
		$('.gfield_select').each(function(){
			var select  = $(this),
				w  = select.data('width') == undefined ? '100%' : select.data('width');

			select.selectpicker({
				style: 'select-control',
				width: w,
				size: 4
			});
		});
	});

	//Header Search
	$('header .search span').click(function() {
	  $(this).parent().addClass('focus').find('.form-control').focus();
	  $(document).keyup(function(e) {
	      if (e.keyCode == 27 || e.keyCode == 13) {
	          $('header .search').removeClass('focus');
	          $(document).unbind('keyup');
	      }
	  });
	});

	$('.slider').each(function(){
		var t = $(this),
			child = t.children().length,
			items = t.attr("data-items") ? t.attr("data-items") : 1,
			loop = t.attr("data-loop") == "false" ? false : true,
			nav = t.attr("data-nav") == "true" ? true : false,
			dots = t.attr("data-dots") == "false" ? false : true,
			autoplay = t.attr('data-autoplay') == "false" ? false : true,
			autoWidth = t.attr('data-autoWidth') == "false" ? false : true,
			autoplayTimeout = t.attr('data-timeout') ? t.attr('data-timeout') : 5000;
		// console.log(items +", "+ loop +", "+ nav +", "+ dots +", "+ autoplay +", "+ autoplayTimeout)
		if ( child >= items && child != 1 ) {
			t.addClass('owl-carousel').each(function(){
				$(this).owlCarousel({
					items: items,
					loop: loop,
					nav: nav,
					navText : ["<span class='fa fa-angle-left'></span>","<span class='fa fa-angle-right'></span>"],
					dots: dots,
					autoplay: autoplay,
					autoplaySpeed: 800,
					autoplayTimeout: autoplayTimeout,
					autoWidth: autoWidth
				});
			});
		};
	});

	$('.ig-slider').each(function(){
		var t = $(this),
			child = t.children().length;
		if ( child >= 5 && child != 1 ) {
			t.addClass('owl-carousel').each(function(){
				$(this).owlCarousel({
					items: 5,
					loop: true,
					nav: true,
					navText : ["<span></span>","<span></span>"],
					dots: false,
					autoplay: true,
					autoWidth: false,
					slideTransition: 'linear',
					// autoplayTimeout: 1000,
					autoplaySpeed: 3000,
					smartSpeed: 3000
				});
			});
		};

		$('button.owl-prev').each(function () {
			var hovered = false;
			var loop = window.setInterval(function () {
				if (hovered) {
					t.trigger('prev.owl.carousel', 1500);
					t.trigger('stop.owl.autoplay');
				}
			}, 1000);

			$(this).hover(
				function () {
					hovered = true;
				},
				function () {
					hovered = false;
				}
			);
		});
		$('button.owl-next').each(function () {
			var hovered = false;
			var loop = window.setInterval(function () {
				if (hovered) {
					t.trigger('next.owl.carousel', 1500);
					t.trigger('stop.owl.autoplay');
				}
			}, 1000);

			$(this).hover(
				function () {
					hovered = true;
				},
				function () {
					hovered = false;
				}
			);
		});
	})

	function sliderXS() {
		var sliderS = $('.slider-xs');
		if ($(window).width() < 1023) {
			sliderS.addClass('owl-carousel');
			sliderS.owlCarousel({
				navText: ["<i class='fas fa-chevron-left'></i>","<i class='fas fa-chevron-right'></i>"],
				items: 1,
				loop: true,
				nav: false,
				dots: true,
				autoplay: true,
				responsive : {
					0 : {
						items: 1
					},
					480 : {
						items: 2
					}
				}
			});
		} else {
			sliderS.trigger('destroy.owl.carousel').removeClass('owl-carousel owl-loaded');
			sliderS.find('.owl-stage-outer').children().unwrap();
		}
	}sliderXS();

	function vSlider() {
		var vSlider = $('.vSlider');
			vSlider.addClass('owl-carousel');
			vSlider.owlCarousel({
				navText: ["<i class='fas fa-chevron-left'></i>","<i class='fas fa-chevron-right'></i>"],
				items: 3,
				loop: true,
				nav: true,
				dots: false,
				autoplay: false,
				center: true,
				autoWidth: true
			});
	}vSlider();

	function gSlider() {
		var gSlider = $('.gSlider');
			gSlider.addClass('owl-carousel');
			gSlider.owlCarousel({
				// navText: ["<i class='fas fa-chevron-left'></i>","<i class='fas fa-chevron-right'></i>"],
				items: 1,
				loop: true,
				nav: false,
				dots: false,
				autoplay: false,
				center: true,
				autoWidth: false,
	      margin: 10,
			});
	}gSlider();

	var SS = $('.slick-sliderd').slick({
    dots: false,
    // autoplay: true,
  	autoplaySpeed: 3000,
    arrows: true,
    vertical: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    slidesToScroll: 1,
    verticalSwiping: true,
    asNavFor: '.slider-cont',
  });

	$('.slick-sliderd .item').click(function() {
    var index = $(this).data('slick-index');
    console.log(index);
    SS.slick('slickGoTo',index);
	});

  $('.slick-sliderm').slick({
    dots: false,
    // autoplay: true,
  	autoplaySpeed: 3000,
    arrows: true,
    speed: 300,
    slidesToShow: 3,
    centerMode: true,
    variableWidth: true,
    asNavFor: '.slider-cont',
  });

  $('.slick-sliderm .item').click(function() {
    var index = $(this).data('slick-index');
    console.log(index);
    SS.slick('slickGoTo',index);
	});

  $('.slider-cont').slick({
    dots: false,
    // autoplay: true,
  	autoplaySpeed: 3000,
    arrows: true,
    vertical: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    slidesToScroll: 1,
    verticalSwiping: false,
    responsive: [
    {
      breakpoint: 769,
      settings: {
        vertical: false,
        // variableWidth: true,
        centerMode: false,
      }
    },
    ]
  });


	$(window).scroll(function() {
		var height = $(window).scrollTop();
		if (height > 300) {
			$('.back-to-top').addClass('show');
		} else {
			$('.back-to-top').removeClass('show');
		}
	});
	$(".back-to-top").click(function(event) {
		event.preventDefault();
		$("html, body").animate({ scrollTop: 0 }, "slow");
		return false;
	});

};

$('.gallery').each(function(){
  var t = $(this),
      col = t.find('.item');
  col.hover(function(){
    col.removeClass('active');
    $(this).addClass('active');
  });
});

// // Content Nav

//   $('.menu-content ul').each(function(){
//   var t = $(this),
//       a = t.find('a'),
//       html = "",
//       select = $('<select class="select select-nav">'),
//       st = $("<div class='select-tab' />");

//   a.each(function(){
//     var link = $(this).attr('href');
//     console.log(link);
//     html+="<option value='"+link+"'>"+$(this).text()+"</option>";
//   })

//   select.html(html);
//   st.append(select);
//   st.insertAfter(t);

//   $('select.select').selectpicker({
//     style: 'select-control',
//     width: '100%',
//     size: 5
//   });
// });

// // Dropdown link
//   $('.select-nav').on('change', function () {
//     var url = $(this).val();
//     if (url) {
//       window.location = url;
//     }
//     return false;
//   });

function moneyParallax(){
  var scrolled = $(window).scrollTop();
  $('.masthead .content').css({'transform':'translateY('+(-(scrolled*0.1))+'px)', 'transition':'unset'});
  $('.masthead .items').css('background-position-y',+(+(scrolled*0.3)-0)+'px');
}

$(function() {
	"use strict";
	$(document).ready(function() {          
		init();
		pScroll();
		AdScroll();
	});
	$(window).resize(function(){
		init();
		pScroll();
		AdScroll();
	});
	$(window).scroll(function() {
		setTimeout(function() {
			animation();
		}, 500);
		moneyParallax()
	});
});